"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const valueIsArray_1 = __importDefault(require("../../typeAssertions/valueIsArray"));
const getErrorMessageNoProjectIdFoundInApp_1 = __importDefault(require("../getErrorMessageNoProjectIdFoundInApp"));
const setDataDBBuilder = ({ isDevelopment }) => async ({ entryVars: { updates: updateInstructions, shouldUpdateDbCache = false, }, callbacks, executeProcesses, processor, functionId, }) => {
    const { updateRenderDBCache, databaseCore } = processor.root;
    const onEnd = () => {
        executeProcesses(undefined, callbacks.onEnd);
    };
    const onError = (message) => {
        executeProcesses(functionId, callbacks.errorProcess, message);
        onEnd();
    };
    if (!Array.isArray(updateInstructions)) {
        onError('Update instructions should be an array');
        return;
    }
    const falsyPaths = [];
    const updates = (updateInstructions || [])
        .reduce((updatesAccum, updateInstruction) => {
        if (!(0, valueIsArray_1.default)(updateInstruction)) {
            throw new Error(`Invalid updateInstruction ${updateInstruction}`);
        }
        const lastItemIndex = updateInstruction.length - 1;
        const updateInfo = updateInstruction[lastItemIndex];
        const pathArray = updateInstruction
            .filter((_, index) => index !== lastItemIndex);
        const containsFalsyValues = pathArray.filter((value) => {
            if (typeof value === 'string') {
                if (value === '') {
                    return true;
                }
                return false;
            }
            if (typeof value === 'number') {
                if (Number.isNaN(value)) {
                    return true;
                }
                return false;
            }
            return true;
        }).length > 0;
        if (containsFalsyValues) {
            const newPath = pathArray.reduce((accum, value) => `${accum}/${value}`, '');
            falsyPaths.push(newPath);
            return updatesAccum;
        }
        return Object.assign(Object.assign({}, updatesAccum), { [pathArray.join('/')]: updateInfo });
    }, {});
    if (falsyPaths.length > 0) {
        onError(`Paths must not have undefined, null or empty values. These paths are wrong: \n ${falsyPaths.join('\n')}`);
        return;
    }
    if (Object.keys(updates).length < 1) {
        onError('No information to update');
        return;
    }
    let executeOnEnd = true;
    const listener = (error) => {
        if (!error) {
            executeProcesses(undefined, callbacks.sucessProcess);
        }
        else {
            executeProcesses(functionId, callbacks.errorProcess, error);
        }
        if (executeOnEnd) {
            executeOnEnd = false;
            onEnd();
        }
    };
    const projectId = processor.root.getProjectId();
    if (!projectId) {
        onError((0, getErrorMessageNoProjectIdFoundInApp_1.default)('setDataDB'));
        return;
    }
    if (databaseCore && (databaseCore === null || databaseCore === void 0 ? void 0 : databaseCore.write)) {
        databaseCore.write({
            updates,
            shouldUpdateDbCache: !!shouldUpdateDbCache,
            projectId,
            listener,
            setRenderDbCache: updateRenderDBCache,
            isDevelopment,
        });
    }
};
exports.default = setDataDBBuilder;
